import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15e22390"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5 w-100" }
const _hoisted_2 = { class: "h4 m-0 bold-weight" }
const _hoisted_3 = {
  key: 0,
  class: "date"
}
const _hoisted_4 = {
  key: 1,
  class: "my-1"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "bold-weight h4 mb-3 answer-section-title" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Vielen Dank für die Anfrage. Die Beantwortung wird derzeit erarbeitet.")
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 3 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Vielen Dank für die Anfrage. Die Beantwortung wird derzeit erarbeitet.")
], -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AskusAttributeBadges = _resolveComponent("AskusAttributeBadges")!
  const _component_WdwDynbox = _resolveComponent("WdwDynbox")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createBlock(_component_WdwDynbox, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openList && _ctx.openList(...args))),
          class: "float-end btn btn-secondary"
        }, "zurück zur Übersicht")
      ]),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.question.title), 1),
      (_ctx.canShowQuestionDate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.formattedDate(_ctx.question.created, true)), 1))
        : _createCommentVNode("", true),
      (_ctx.question.attributes)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_AskusAttributeBadges, {
              question: _ctx.question,
              attributes: _ctx.question.attributes
            }, null, 8, ["question", "attributes"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, _toDisplayString(_ctx.question.content), 1),
      _hoisted_5,
      (_ctx.answers.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answers, (answer) => {
              return (_openBlock(), _createElementBlock("div", {
                key: answer.id
              }, [
                (answer.answer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, "Antwort von " + _toDisplayString(answer.owner.public_name), 1),
                      _withDirectives(_createElementVNode("p", null, null, 512), [
                        [_directive_dompurify_html, answer.answer]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
    ]),
    _: 1
  }))
}